import { CanActivateFn, CanDeactivateFn } from '@angular/router';
import { ResetMenuTheme, SetMenuTheme } from '../store';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';

export const menuThemeGuard: CanActivateFn = route => {
  const store = inject(Store);
  const theme = route.data['navTheme'];

  if (theme) {
    store.dispatch(SetMenuTheme(theme));
  }
  return true;
};

export const resetMenuThemeGuard: CanDeactivateFn<any> = () => {
  const store = inject(Store);
  store.dispatch(ResetMenuTheme());
  return true;
};
